/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Modal, Button } from 'reactstrap';
import { connect } from 'react-redux';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from './../Order.sass';
import { addOrderAddress } from '../../../actions/order';

const staticGoogleMapKey = process.env.GOOGLE_MAP_API_KEY;
class Order09PathStaticMap extends React.Component {
  static propTypes = {
    openModal: PropTypes.bool.isRequired,
    activeSuggestion: PropTypes.shape({
      description: PropTypes.string,
      id: PropTypes.string,
      geometry: PropTypes.shape({
        location: PropTypes.shape({
          lat: PropTypes.number,
          lng: PropTypes.number,
        }),
      }),
    }).isRequired,
    onClickToggleStaticMap: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      modal: props.openModal,
      staticMapUrl: '',
    };
    this.toggle = this.toggle.bind(this);
  }

  // Need Gogovan Key and signature
  componentWillReceiveProps(nextProps) {
    if (nextProps.openModal !== this.props.openModal) {
      this.setState({ modal: nextProps.openModal });
      const url = `https://maps.googleapis.com/maps/api/staticmap?center=${
        nextProps.activeSuggestion.geometry.location.lat
        },${
        nextProps.activeSuggestion.geometry.location.lng
        }&size=620x380&sensor=true&zoom=16&scale=1&markers=icon:http://www.gogovan.com.hk/img/map_marker_1.png%7C${
        nextProps.activeSuggestion.geometry.location.lat
        },${
        nextProps.activeSuggestion.geometry.location.lng
        }&scale=1.100000023841858&key=${staticGoogleMapKey}`;
      this.setState({ staticMapUrl: url });
    }
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
    this.props.onClickToggleStaticMap(false);
    this.setState({ staticMapUrl: '' });
  }

  render() {
    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        className={`${s.infoPopup} ${s2.staticMapInfo}`}
      >
        <Button
          outline
          color="link"
          onClick={this.toggle}
          className={`${s2.infoCloseRightButton}`}
        />
        <img
          className={s2.staticMap}
          src={this.state.staticMapUrl}
          alt="staticMap"
        />
      </Modal>
    );
  }
}
const mapState = state => ({
  address: state.order.address,
});

const mapDispatch = {
  addOrderAddress,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(Order09PathStaticMap),
);



// WEBPACK FOOTER //
// ./src/routes/order/order09Path/Order09PathStaticMap.js